import { atom } from "recoil";
import { RecoilAtoms } from "../config/recoil-atoms";
import { Location } from "models";

export const userLocationAtom = atom<Location>({
  key: RecoilAtoms.USER_LOCATION,
  default: {} as Location,
});
